import { TableColumn } from '@maersk-global/mds-components-core/mc-table/types';

export const defaultValuesTableColumns: TableColumn[] = [
  { id: 'yardCapacity', label: 'Safe Yard TEU Capacity', sortDisabled: true, align: 'left', width: '140px' },
  { id: 'reeferPlugs', label: 'Reefer plugs', align: 'left', sortDisabled: true },
  {
    id: 'imoUnits',
    label: 'IMO units',
    align: 'left',
    sortDisabled: true,
    description: 'This data is compulsory and shared with the line',
  },
  { id: 'oogUnits', label: 'OOG units', align: 'left', sortDisabled: true },
  {
    id: 'ladenCapacity',
    label: 'Laden TEUs',
    align: 'left',
    sortDisabled: true,
    width: '140px',
    description: 'Laden TEUs benchmark (For internal APMT use, not shared with the line)',
  },
  {
    id: 'emptyCapacity',
    label: 'Empty TEUs',
    align: 'left',
    sortDisabled: true,
    width: '140px',
    description: 'Empty TEUs benchmark (For internal APMT use, not shared with the line)',
  },
  {
    id: 'maxCapacity',
    label: 'Max TEU Capacity',
    align: 'left',
    sortDisabled: true,
    width: '140px',
    description: 'Max TEU Capacity is for internal APMT use only, not shared with the line',
  },
  { id: 'validityPeriod', label: 'Validity period', align: 'left', sortDisabled: true, width: '230px' },
  { id: 'actions', label: 'Actions', align: 'right', sortDisabled: true },
];

export const weeklyValuesTableColumns: TableColumn[] = [
  { id: 'carrier', label: '', align: 'left', sortDisabled: true, width: '120px' },
  { id: 'date', label: 'Date', align: 'left' },
  { id: 'yardCapacity', label: 'Safe Yard TEU Capacity', align: 'left', width: '160px' },
  { id: 'reeferPlugs', label: 'Reefer plugs', align: 'left', width: '120px' },
  { id: 'imoUnits', label: 'IMO units', align: 'left' },
  { id: 'oogUnits', label: 'OOG units', align: 'left' },
  { id: 'ladenCapacity', label: 'Laden TEUs', align: 'left' },
  { id: 'emptyCapacity', label: 'Empty TEUs', align: 'left' },
  { id: 'maxCapacity', label: 'Max TEU Capacity', align: 'left', width: '140px' },
  { id: 'status', label: 'Status', align: 'left' },
  { id: 'actions', label: 'Actions', align: 'right', width: '200px', sortDisabled: true },
];
